module.exports = __webpack_public_path__ + "2c675b467f82adf1caf51af0977934e0.pdf";